import queryString from 'query-string';

export default class CurrentPage {
  static hasHash(string) {
    return window.location.hash === `#${string}`;
  }

  static setHash(string) {
    window.location.hash = `#${string}`;
  }

  static isArticle() {
    return window.ENV && window.ENV.article && window.ENV.article.id > 0;
  }

  static isArticlePreview() {
    return queryString.parse(window.location.search)?.preview === 'true';
  }

  static getArticleId() {
    if (this.isArticle()) {
      return window.ENV.article.id;
    } else {
      return -1;
    }
  }

  static getArticleAuthorId() {
    if (this.isArticle()) {
      return window.ENV.article.authorId;
    } else {
      return -1;
    }
  }

  static getArticleConversationHostId() {
    if (this.isArticle()) {
      return window.ENV.article.conversationHostId;
    } else {
      return -1;
    }
  }

  static getArticleUrl() {
    if (this.isArticle()) {
      return window.ENV.article.url;
    } else {
      return '';
    }
  }

  static getArticleUrlSafeTitle() {
    if (this.isArticle()) {
      return window.ENV.article.urlSafeTitle;
    } else {
      return '';
    }
  }

  static getTrackMetricsActionPath() {
    return window.ENV.trackMetricsActionPath;
  }

  static getUserGoalMarkTrackedActionPath() {
    return window.ENV.userGoalMarkTrackedActionPath;
  }

  static hasShareUrl() {
    return window.ENV && window.ENV.shareUrl && typeof window.ENV.shareUrl.id == 'number';
  }

  static getShareUrl() {
    return window.ENV.shareUrl;
  }

  static isAccessWallIframeLocked() {
    return window.ENV.accessWall && !window.ENV.accessWall.isUnlocked;
  }

  static accessWallIframeSrc() {
    return window.ENV.accessWall.src;
  }

  static accessWallIframeId() {
    return window.ENV.accessWall.id;
  }

  // Returns the current URL without the anchor.
  static getUrl() {
    return window.location.href.match(/(^[^#]*)/)[0];
  }
}
